var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGranite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 505 513.4",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C4E1E8",
    d: "M470.2 476.8c-10.3 20.6-20.9 33.7-29.1 36.6H336.3c-8.2-2.9-18.9-16-29.1-36.6zM490.5 185H286.9c8.4-37.7 17.4-61 17.4-61h168.8s9 23.3 17.4 61",
    opacity: 1,
    "data-original": "#c4e1e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3C539",
    d: "M505 314.7c-.4 67.8-17 126.3-34.8 162.1h-163c-17.8-35.8-34.4-94.3-34.8-162.1-.3-50.5 6.9-95.8 14.5-129.7h203.6c7.6 33.9 14.8 79.2 14.5 129.7",
    opacity: 1,
    "data-original": "#a3c539"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66A438",
    d: "M393.464 267.816 456.538 6.93l11.664 2.82-63.074 260.885z",
    opacity: 1,
    "data-original": "#66a438"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 346.4,
    r: 78.9,
    fill: "#66A438",
    opacity: 1,
    "data-original": "#66a438"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 382,
    cy: 346.4,
    fill: "#C9C15C",
    rx: 43.7,
    ry: 30.4,
    opacity: 1,
    "data-original": "#c9c15c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#A3C539"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.8 340.4h13.4v12h-13.4zM375.9 379.2h12v16.1h-12zM397.124 377.796l10.716-5.412 7.26 14.378-10.715 5.412zM417.676 328.626l12.187-10.514 7.836 9.084-12.187 10.513zM403.782 315.691l9.58-12.944 9.648 7.14-9.58 12.944zM385.1 298h12v16.1h-12zM415.04 367.829l7.055-9.708 13.025 9.467-7.056 9.708z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C4E1E8",
    d: "M197.8 476.8c-10.2 20.6-20.9 33.7-29.1 36.6H63.9c-8.2-2.9-18.8-16-29.1-36.6zM218.1 185H14.5c8.4-37.7 17.4-61 17.4-61h168.8s9 23.3 17.4 61",
    opacity: 1,
    "data-original": "#c4e1e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3644",
    d: "M232.6 314.7c-.4 67.8-17 126.3-34.8 162.1h-163C17 441 .4 382.5 0 314.7c-.3-50.5 6.9-95.8 14.5-129.7h203.6c7.6 33.9 14.8 79.2 14.5 129.7",
    opacity: 1,
    "data-original": "#db3644"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE1E2D",
    d: "m31.792 9.798 11.664-2.82 81.733 338.061-11.664 2.82zM157.2 415.3c4.7 15.9.3 33.2-3.7 49.2-5.3 21.1-13.3 39.6-31.5 45s-32.5-8.1-48.4-22.7c-12.3-11.2-27.7-20.9-32.4-37.1-11-37 9-64.8 41-74.3s64 2.9 75 39.9",
    opacity: 1,
    "data-original": "#be1e2d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66A438",
    d: "M52.8 362.3c11.1-5.2 23.2-2.7 27 5.4s-2.1 19-13.2 24.2-33.8-2.3-33.8-2.3 8.9-22.1 20-27.3M105.5 346.6c-12.1 2-20.6 10.9-19.1 19.7s12.5 14.5 24.5 12.4 26.6-21 26.6-21-19.9-13.2-32-11.1",
    opacity: 1,
    "data-original": "#66a438"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66A438",
    d: "M61 389.4c6.2-10.6 17.5-15.5 25.3-10.9s9 16.8 2.8 27.3S60 423.2 60 423.2s-5.2-23.3 1-33.8",
    opacity: 1,
    "data-original": "#66a438"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66A438",
    d: "M115.8 373.1c-11-5.5-23.1-3.4-27.2 4.7s1.6 19 12.6 24.5 33.8-1.4 33.8-1.4-8.3-22.3-19.2-27.8",
    opacity: 1,
    "data-original": "#66a438"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE1E2D",
    d: "M78.5 369.1c-.3-.7-8.8-17.2-5.7-34 1.4-7.7 5.5-14.6 11.6-19.4l7 9.8c-3.6 3-6 7.1-6.8 11.7-2.3 12.6 4.5 26.3 4.6 26.4z",
    opacity: 1,
    "data-original": "#be1e2d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3644",
    d: "m69.737 441.038 7.32-9.504 11.563 8.906-7.32 9.504zM116.845 472.868l7.32-9.504 11.563 8.906-7.32 9.504zM116.138 424.468l11.988-.588.715 14.586-11.988.588zM94.036 455.374l11.988-.588.715 14.586-11.988.588z",
    opacity: 1,
    "data-original": "#db3644"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7EEF2",
    d: "M332.4 476.8c-10.2 20.6-20.9 33.7-29 36.6H198.5c-8.2-2.9-18.8-16-29.1-36.6zM352.8 185H149.1c8.4-37.7 17.5-61 17.5-61h168.7s9 23.3 17.5 61",
    opacity: 1,
    "data-original": "#d7eef2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE148",
    d: "M367.2 314.7c-.3 67.8-16.9 126.3-34.8 162.1h-163c-17.8-35.8-34.4-94.3-34.8-162.1-.2-50.5 6.9-95.8 14.5-129.7h203.7c7.6 33.9 14.7 79.2 14.4 129.7",
    opacity: 1,
    "data-original": "#fce148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA9903",
    d: "M166.885 2.862 178.55.042l90.734 375.289-11.664 2.82zM229.8 89.4l101.5 83 15.4 12.6c30.4-45.4 20.3-92.8-12.6-119.6s-86.1-30.1-118.7 12z",
    opacity: 1,
    "data-original": "#ea9903"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0CF31",
    d: "M331.3 172.4c21.9-28.9 16.3-70-12.6-91.9-27.4-20.8-66.2-16.9-88.9 8.9z",
    opacity: 1,
    "data-original": "#f0cf31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE148",
    d: "m275.816 127.07 41.525-50.774 9.288 7.596-41.525 50.775z",
    opacity: 1,
    "data-original": "#fce148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE148",
    d: "m267.938 66.44 11.94-1.188 6.495 65.272-11.94 1.188z",
    opacity: 1,
    "data-original": "#fce148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE148",
    d: "m279.714 125.173 65.272-6.494 1.188 11.94-65.272 6.494z",
    opacity: 1,
    "data-original": "#fce148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66A438",
    d: "m372.68 222.627 9.72-7.032 8.555 11.826-9.72 7.032zM465.257 284.746l9.72-7.032 8.556 11.826-9.72 7.032zM451.55 231.566l3.46-14.192 11.665 2.844-3.46 14.191zM393.147 450.544l3.46-14.191 11.664 2.844-3.46 14.19zM454.912 423.55l3.46-14.192 11.664 2.844-3.46 14.191z",
    opacity: 1,
    "data-original": "#66a438"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#EA9903"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m292.05 290.723 9.72-7.032 8.556 11.826-9.72 7.032zM204.84 315.74l9.72-7.033 8.556 11.826-9.72 7.032zM281.731 253.993l3.46-14.191 11.665 2.844-3.46 14.191zM183.344 384.588l3.46-14.192 11.664 2.844-3.46 14.191zM293.873 382.147l3.46-14.191 11.664 2.844-3.46 14.19zM234.799 436.795l3.46-14.191 11.664 2.844-3.46 14.19z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BE1E2D",
    d: "m31.117 222.698 9.72-7.032 8.555 11.826-9.72 7.032zM64.758 260.696l9.72-7.032 8.555 11.826-9.72 7.032zM106.875 215.568l3.46-14.19 11.664 2.843-3.46 14.191zM43.109 305.9l3.46-14.191 11.664 2.844-3.46 14.191zM23.682 351.945l3.46-14.191 11.664 2.844-3.46 14.19z",
    opacity: 1,
    "data-original": "#be1e2d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGranite);
export default __webpack_public_path__ + "static/media/Granite.6e5554051988ec10eb869535d420eacf.svg";
export { ForwardRef as ReactComponent };